export default __webpack_public_path__ + "static/media/favicon.5db9d343.png";